<template>
    <app-layout title="Nastavení">

        <settings-tabs-navigation/>

        <div class="font-sans antialiased min-h-screen bg-gray-100">
            <div class="min-h-screen flex">

                <div class="flex-1">

                    <!-- Main Content -->
                    <div class="mb-6 pt-6 lg:pt-12 lg:max-w-4xl lg:mx-auto">
                        <!-- Error Messages -->
                        <error-messages class="mb-10 sm:px-8" :errors="errors" v-if="errors.length > 0"/>

                        <!-- Subscription Form (Shown After A Plan Is Selected) -->
                        <div v-show="subscribing">
                            <section-heading class="px-4 sm:px-8">
                                Výběr plánu
                            </section-heading>

                            <div class="mt-6 sm:px-8">
                                <div class="bg-white sm:rounded-lg shadow-sm overflow-hidden" v-if="subscribing">
                                    <plan :plan="subscribing" :seat-name="$page.props.seatName"/>
                                </div>

                                <div class="mt-6 bg-white sm:rounded-lg shadow-sm overflow-hidden">
                                    <div class="px-6 py-4">
                                        <h2 class="text-xl font-semibold text-gray-700">
                                            Platební údaje
                                        </h2>

                                        <div class="mt-4 flex items-center">
                                            <fieldset class="space-y-5">
                                                <div class="relative flex items-start">
                                                    <div class="flex items-center h-5">
                                                        <input v-model="subscriptionForm.paymentLater" id="paymentLater" type="checkbox" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                                                    </div>
                                                    <div class="ml-3 text-sm">
                                                        <label for="paymentLater" class="font-medium text-gray-700"> Platba v dalším kroku </label>
                                                        <p class="text-gray-500">Platební údaje můžete zadat i v dalším kroku - přímo u provozovatele platební brány.</p>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>

                                        <div class="mt-4" v-show="!subscriptionForm.paymentLater">
                                            <span class="block text-sm font-medium text-gray-700 mt-4"> Platební karta </span>

                                            <div id="card-element" class="w-full bg-white border border-gray-200 p-3 rounded"></div>
                                        </div>

                                        <div class="mt-1 flex items-center" v-if="!showingCouponCode && !subscriptionForm.paymentLater">
                                            <button class="w-full text-gray-400 text-sm underline text-left active:outline-none focus:outline-none" @click="showCouponCode">
                                                Máte kupón?
                                            </button>
                                        </div>

                                        <div class="mt-4" v-if="showingCouponCode">
                                            <jet-label for="coupon" > Kupón </jet-label>

                                            <input type="text" id="coupon" ref="coupon"
                                                   v-model="subscriptionForm.coupon"
                                                   :placeholder="'Kupón'"
                                                   @keyup.enter="confirmSubscription"
                                                   class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                        </div>

                                        <template v-if="true">

                                            <h2 class="text-xl mt-4 font-semibold text-gray-700">
                                                Fakturační údaje
                                            </h2>

                                            <div class="mt-4">
                                                <jet-label required for="name" > Jméno / Název </jet-label>

                                                <input type="text" id="name" ref="name"
                                                       v-model="subscriptionForm.name"
                                                       :placeholder="'Jméno / Název'"
                                                       class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                            </div>

                                            <div class="mt-4 flex items-center grid grid-cols-2 gap-2">
                                                <div class="">
                                                    <jet-label for="id_number"> IČO </jet-label>

                                                    <input type="text" id="id_number" ref="id_number"
                                                           v-model="subscriptionForm.id_number"
                                                           :placeholder="'IČO'"
                                                           class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                                </div>

                                                <div class="">
                                                    <jet-label for="vat"> DIČ </jet-label>

                                                    <input type="text" id="vat" ref="vat"
                                                           v-model="subscriptionForm.vat"
                                                           :placeholder="'DIČ'"
                                                           class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                                </div>
                                            </div>

                                            <div class="mt-4">
                                                <jet-label required for="address" > Adresa </jet-label>

                                                <input type="text" id="address" ref="address"
                                                       v-model="subscriptionForm.address"
                                                       :placeholder="'Adresa'"
                                                       class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                            </div>

                                            <div class="mt-4 flex items-center grid md:grid-cols-3 grid-cols-1 md:gap-2">
                                                <div class="md:col-span-2">
                                                    <jet-label required for="city"> Město </jet-label>

                                                    <input type="text" id="city" ref="city"
                                                           v-model="subscriptionForm.city"
                                                           :placeholder="'Město'"
                                                           class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                                </div>

                                                <div class="md:col-span-1 md:mt-0 mt-4">
                                                    <jet-label required for="postal_code"> PSČ </jet-label>

                                                    <input type="text" id="postal_code" ref="postal_code"
                                                           v-model="subscriptionForm.postal_code"
                                                           :placeholder="'PSČ'"
                                                           class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                                </div>
                                            </div>

                                            <div class="mt-4">
                                                <jet-label required for="country"> Stát </jet-label>

                                                <select name="country" id="country"
                                                        v-model="subscriptionForm.country"
                                                        class="form-select mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                                    <option value="" disabled=""> Vyberte </option>
                                                    <option v-for="(name, iso) in $page.props.countries" :value="iso">{{ name }}</option>
                                                </select>
                                            </div>
                                        </template>

                                        <div v-if="enforcesAcceptingTerms" class="mt-6 flex">
                                            <jet-label required for="terms" class="w-1/3 mr-10 mt-2 text-gray-800 text-sm font-semibold"></jet-label>

                                            <div class="flex items-center w-full">
                                                <input class="" type="checkbox" name="accept" id="terms" v-model="subscriptionForm.accept">
                                                <a class="ml-2 text-sm font-semibold underline" :href="$page.props.termsUrl"> Souhlasím s obchodními podmínkami. </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="px-6 py-4 mt-5 bg-gray-100 bg-opacity-50 border-t border-gray-100 flex items-center">
                                        <div v-if="! loadingTaxCalculations">
                                            <span v-if="checkoutAmount" v-html="'Celkem:' + ' ' + checkoutAmount"></span>
                                            <span v-if="checkoutTax" v-html="'(' + checkoutTax + ' ' + 'DPH' + ')'" class="ml-1 text-gray-600"></span>
                                        </div>

                                        <div v-else>
                                            ...
                                        </div>

                                        <spark-button v-if="!subscriptionForm.paymentLater" class="ml-auto"
                                                      @click.native="confirmSubscription"
                                                      :disabled="! (stripeInputsCompleted
                                                                    && subscriptionForm.name
                                                                    && subscriptionForm.address
                                                                    && subscriptionForm.city
                                                                    && subscriptionForm.postal_code
                                                                    && subscriptionForm.country
                                                                    )"
                                                      ref="confirmSubscriptionButton">
                                            Vybrat
                                        </spark-button>
                                        <spark-button v-else class="ml-auto"
                                                      @click.native="redirectToConfirmSubscription"
                                                      :disabled="! (   subscriptionForm.name
                                                                    && subscriptionForm.address
                                                                    && subscriptionForm.city
                                                                    && subscriptionForm.postal_code
                                                                    && subscriptionForm.country
                                                                    )"
                                                      ref="confirmSubscriptionButton">
                                            Pokračovat k platbě
                                        </spark-button>

                                    </div>
                                </div>
                            </div>

                            <!-- Nevermind -->
                            <button class="flex items-center mt-4 px-4 sm:px-8" @click="subscribing = false">
                                <svg viewBox="0 0 20 20" fill="currentColor" class="text-gray-400 w-4 h-4">
                                    <path fill-rule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clip-rule="evenodd"></path>
                                </svg>

                                <div class="ml-2 text-sm text-gray-600 underline">
                                    Vybrat jiný plán
                                </div>
                            </button>
                        </div>

                        <div v-show="! subscribing">
                            <!-- Subscribe -->
                            <div v-if="$page.props.state == 'none'">
                                <section-heading class="px-4 sm:px-8">
                                    Výběr plánu
                                </section-heading>

                                <div class="mt-6 sm:px-8">
                                    <info-messages class="mb-10" v-if="! $page.props.genericTrialEndsAt">
                                        Nemáte aktivní žádné předplatné. Vyberte, prosím, jeden z plánů ze seznamu níže. Předplatné můžete kdykoli změnit nebo zrušit dle libosti.
                                    </info-messages>

                                    <info-messages class="mb-10" v-else>
                                        {{ 'Právě využíváte DSchránku na zkoušku. Zkušební období skončí ' + $page.props.genericTrialEndsAt + '.' }}
                                    </info-messages>
                                </div>

                                <!-- Interval Selector -->
                                <interval-selector class="mt-6 px-4 sm:px-8"
                                                   :showing-default-interval-plans="showingPlansOfInterval == $page.props.defaultInterval"
                                                   @toggled="toggleDisplayedPlanIntervals"
                                                   v-if="monthlyPlans.length > 0 && yearlyPlans.length > 0"/>


                                <!-- Monthly Plans -->
                                <plan-list class="mt-6 sm:px-8" key="subscribe-monthly-plans"
                                           :plans="monthlyPlans"
                                           interval="monthly"
                                           :seat-name="seatName"
                                           :current-plan="plan"
                                           @plan-selected="startSubscribingToPlan($event)"
                                           v-if="monthlyPlans.length > 0 && showingPlansOfInterval == 'monthly'"/>



                                <!-- Yearly Plans -->
                                <plan-list class="mt-6 sm:px-8" key="subscribe-yearly-plans"
                                           :plans="yearlyPlans"
                                           interval="yearly"
                                           :seat-name="seatName"
                                           :current-plan="plan"
                                           @plan-selected="startSubscribingToPlan($event)"
                                           v-if="yearlyPlans.length > 0 && showingPlansOfInterval == 'yearly'"/>

                            </div>

                            <!-- Active Subscription -->
                            <div v-if="$page.props.state == 'active'">
                                <!-- Change Subscription Plan -->
                                <section-heading class="px-4 sm:px-8" v-if="! selectingNewPlan">
                                    Aktuální plán
                                </section-heading>

                                <section-heading class="px-4 sm:px-8" v-else>
                                    Změnit plán
                                </section-heading>

                                <div class="mt-3 sm:px-8">
                                    <info-messages class="mb-10" v-if="$page.props.trialEndsAt">
                                        {{ 'Právě využíváte DSchránku na zkoušku. Zkušební období skončí ' + $page.props.trialEndsAt + '.' }}
                                    </info-messages>

                                    <div class="bg-white sm:rounded-lg shadow-sm" v-if="! selectingNewPlan">
                                        <plan :plan="plan" :seat-name="seatName" :hide-incentive="true"/>

                                        <div class="px-6 pb-4">
                                            <spark-button class="mt-4" v-if="(monthlyPlans.length + yearlyPlans.length) > 1"
                                                          @click.native="selectingNewPlan = true">
                                                Změnit
                                            </spark-button>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="selectingNewPlan">
                                    <!-- Interval Selector -->
                                    <interval-selector class="mt-6 px-4 sm:px-8"
                                                       :showing-default-interval-plans="showingPlansOfInterval == $page.props.defaultInterval"
                                                       @toggled="toggleDisplayedPlanIntervals"
                                                       v-if="monthlyPlans.length > 0 && yearlyPlans.length > 0"/>


                                    <!-- Monthly Plans -->
                                    <plan-list class="mt-6 sm:px-8" key="change-monthly-plans"
                                               :plans="monthlyPlans"
                                               interval="monthly"
                                               :seat-name="seatName"
                                               :current-plan="plan"
                                               @plan-selected="switchToPlan($event)"
                                               v-if="monthlyPlans.length > 0 && showingPlansOfInterval == 'monthly'"/>

                                    <!-- Yearly Plans -->
                                    <plan-list class="mt-6 sm:px-8" key="change-yearly-plans"
                                               :plans="yearlyPlans"
                                               interval="yearly"
                                               :current-plan="plan"
                                               :seat-name="seatName"
                                               @plan-selected="switchToPlan($event)"
                                               v-if="yearlyPlans.length > 0 && showingPlansOfInterval == 'yearly'"/>


                                    <!-- Nevermind, Keep Old Plan -->
                                    <button class="flex items-center mt-4 px-4 sm:px-8" @click="selectingNewPlan = false">
                                        <svg viewBox="0 0 20 20" fill="currentColor" class="text-gray-400 w-4 h-4">
                                            <path fill-rule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clip-rule="evenodd"></path>
                                        </svg>

                                        <div class="ml-2 text-sm text-gray-600 underline">
                                            Zpět a ponechat stávající
                                        </div>
                                    </button>
                                </div>

                                <!-- Update Billing Information -->
                                <div class="mt-10" v-if="!selectingNewPlan">
                                    <section-heading class="px-4 sm:px-8">
                                        Způsob platby
                                    </section-heading>

                                    <div class="mt-3 sm:px-8">
                                        <div class="bg-white sm:rounded-lg shadow-sm overflow-hidden">
                                            <div class="px-6 py-4">
                                                <p class="max-w-2xl text-sm text-gray-600" v-if="$page.props.paymentMethod == 'card'"
                                                   v-html="'Aktuální způsob platby je platební karta končící '
                                               +'<span class=\'font-semibold\'>'+$page.props.cardLastFour+'</span>'
                                               +' platná do ' + '<span class=\'font-semibold\'>'+$page.props.cardExpirationDate+'</span>' +'.'
                                              ">
                                                </p>

                                                <spark-button class="mt-4" @click.native="updatingPaymentMethod = true" v-if="!updatingPaymentMethod">
                                                    Změnit způsob platby
                                                </spark-button>

                                                <div class="mt-6" v-if="updatingPaymentMethod">
                                                    <span class="block text-sm font-medium text-gray-700 mt-4"> Platební karta </span>

                                                    <div id="payment-card-element" class="w-full border border-gray-200 p-3 rounded"></div>
                                                </div>

                                                <template v-if="updatingPaymentMethod && (collectsVat || collectsBillingAddress)">
                                                    <div v-if="collectsVat"
                                                         class="mt-6 flex items-center">
                                                        <jet-label for="vat" > DIČ </jet-label>

                                                        <input type="text" id="vat" ref="vat"
                                                               v-model="paymentInformationForm.vat"
                                                               :placeholder="'DIČ'"
                                                               class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                                    </div>

                                                    <div class="mt-4">
                                                        <jet-label required for="address" > Adresa </jet-label>

                                                        <input type="text" id="address" ref="address"
                                                               v-model="paymentInformationForm.address"
                                                               :placeholder="'Address'"
                                                               class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                                    </div>

                                                    <div class="mt-4">
                                                        <jet-label required for="city" > Město </jet-label>

                                                        <input type="text" id="city" ref="city"
                                                               v-model="paymentInformationForm.city"
                                                               :placeholder="'City'"
                                                               class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                                    </div>

                                                    <div class="mt-4">
                                                        <jet-label required for="postal_code" > PSČ </jet-label>

                                                        <input type="text" id="postal_code" ref="postal_code"
                                                               v-model="paymentInformationForm.postal_code"
                                                               :placeholder="'PSČ'"
                                                               class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                                    </div>

                                                    <div class="mt-4">
                                                        <jet-label required for="country"> Stát </jet-label>

                                                        <select name="country" id="country"
                                                                v-model="paymentInformationForm.country"
                                                                class="form-select mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                                            <option value="" disabled=""> Vyberte </option>
                                                            <option v-for="(name, iso) in $page.props.countries" :value="iso">{{ name }}</option>
                                                        </select>
                                                    </div>
                                                </template>
                                            </div>

                                            <div class="px-6 py-4 mt-5 bg-gray-100 bg-opacity-50 border-t border-gray-100 text-right" v-if="updatingPaymentMethod">
                                                <spark-button @click.native="updatePaymentMethod" ref="updatePaymentMethodButton">
                                                    Změnit způsob platby
                                                </spark-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Apply Coupons -->
                                <section-heading class="mt-10 px-4 sm:px-8">
                                    Použít kupón
                                </section-heading>

                                <div class="mt-3 sm:px-8">
                                    <div class="bg-white sm:rounded-lg shadow-sm">
                                        <div class="px-6 py-4 ">
                                            <div class="mt-6">
                                                <jet-label for="coupon_for_existing" > Kupón </jet-label>

                                                <input type="text" id="coupon_for_existing" ref="coupon_for_existing"
                                                       v-model="couponForm.coupon"
                                                       :placeholder="'Kupón'"
                                                       class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                            </div>
                                        </div>

                                        <div class="px-6 py-4 mt-5 bg-gray-100 bg-opacity-50 border-t border-gray-100 text-right">
                                            <spark-button @click.native="applyCoupon">
                                                Použít
                                            </spark-button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Cancel Subscription -->
                                <section-heading class="mt-10 px-4 sm:px-8">
                                    Zrušit předplatné
                                </section-heading>

                                <div class="mt-3 sm:px-8">
                                    <div class="px-6 py-4 bg-white sm:rounded-lg shadow-sm">
                                        <div class="max-w-2xl text-sm text-gray-600">
                                            Předplatné můžete kdykoli zrušit dle libosti. Po zrušení předplatného budete mít možnost ho jednoduše obnovit až do konce aktuálního zůčtovacího období.
                                        </div>

                                        <div class="mt-4">
                                            <spark-secondary-button @click.native="cancelSubscription">
                                                Zrušit předplatné
                                            </spark-secondary-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- On Grace Period / Subscription Paused -->
                            <div v-if="$page.props.state == 'onGracePeriod'">
                                <!-- Resume Subscription -->
                                <section-heading class="px-4 sm:px-8">
                                    Obnovit předplatné
                                </section-heading>

                                <div class="mt-3 sm:px-8">
                                    <div class="px-6 py-4 bg-white sm:rounded-lg shadow-sm">
                                        <div class="max-w-2xl text-sm text-gray-600">
                                            Rozmysleli jste si zrušení předplatného? Můžete ho do konce aktuálního zůčtovacího období jednoduše obnovit! Po skončení zůčtovacího období pak můžete vybrat úplně nový plán.
                                        </div>

                                        <div class="mt-4">
                                            <spark-button @click.native="resumeSubscription">
                                                Obnovit předplatné
                                            </spark-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Extra Billing Information -->
                            <div class="mt-10" v-if="$page.props.state != 'none' && !selectingNewPlan">
                                <section-heading class="px-4 sm:px-8">
                                    Fakturační údaje
                                </section-heading>

                                <div class="mt-3 sm:px-8">
                                    <div class="bg-white sm:rounded-lg shadow-sm">
                                        <div class="px-6 py-4 ">
                                            <div class="mt-4">
                                                <jet-label required for="name" > Jméno / Název </jet-label>

                                                <input type="text" id="name" ref="name"
                                                       v-model="billingInformationForm.name"
                                                       :placeholder="'Jméno / Název'"
                                                       class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                            </div>

                                            <div class="mt-4 flex items-center grid grid-cols-2 gap-2">
                                                <div class="">
                                                    <jet-label for="id_number"> IČO </jet-label>

                                                    <input type="text" id="id_number" ref="id_number"
                                                           v-model="billingInformationForm.id_number"
                                                           :placeholder="'IČO'"
                                                           class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                                </div>

                                                <div class="">
                                                    <jet-label for="vat"> DIČ </jet-label>

                                                    <input type="text" id="vat" ref="vat"
                                                           v-model="billingInformationForm.vat"
                                                           :placeholder="'DIČ'"
                                                           class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                                </div>
                                            </div>

                                            <div class="mt-4">
                                                <jet-label required for="address"> Adresa </jet-label>

                                                <input type="text" id="address" ref="address"
                                                       v-model="billingInformationForm.address"
                                                       :placeholder="'Adresa'"
                                                       class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                            </div>

                                            <div class="mt-4 flex items-center grid md:grid-cols-3 grid-cols-1 md:gap-2">
                                                <div class="md:col-span-2">
                                                    <jet-label required for="city"> Město </jet-label>

                                                    <input type="text" id="city" ref="city"
                                                           v-model="billingInformationForm.city"
                                                           :placeholder="'Město'"
                                                           class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                                </div>

                                                <div class="md:col-span-1 md:mt-0 mt-4">
                                                    <jet-label required for="postal_code"> PSČ </jet-label>

                                                    <input type="text" id="postal_code" ref="postal_code"
                                                           v-model="billingInformationForm.postal_code"
                                                           :placeholder="'PSČ'"
                                                           class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                                </div>
                                            </div>

                                            <div class="mt-4">
                                                <jet-label required for="country"> Stát </jet-label>

                                                <select name="country" id="country"
                                                        v-model="billingInformationForm.country"
                                                        class="form-select mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                                    <option value="" disabled=""> Vyberte </option>
                                                    <option v-for="(name, iso) in $page.props.countries" :value="iso">{{ name }}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="px-6 py-4 mt-5 bg-gray-100 bg-opacity-50 border-t border-gray-100 text-right">
                                            <spark-button @click.native="updateBillingInformation" :disabled="! (billingInformationForm.name
                                                                                                              && billingInformationForm.address
                                                                                                              && billingInformationForm.city
                                                                                                              && billingInformationForm.postal_code
                                                                                                              && billingInformationForm.country)">
                                                Uložit
                                            </spark-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Receipts Emails -->
                            <div class="mt-10" v-if="$page.props.sendsReceiptsToCustomAddresses">
                                <section-heading class="px-4 sm:px-8">
                                    Receipt Email Addresses
                                </section-heading>

                                <div class="mt-3 sm:px-8">
                                    <div class="bg-white sm:rounded-lg shadow-sm">
                                        <div class="px-6 py-4 ">
                                            <div class="max-w-2xl text-sm text-gray-600">
                                                We will send a receipt download link to the email addresses that you specify below. You may separate multiple email addresses using commas.
                                            </div>

                                            <div class="mt-6 flex">
                                                <jet-label required for="receipt_emails" class="w-1/3 mr-10 mt-2 text-gray-800 text-sm font-semibold"> Email Addresses </jet-label>

                                                <input type="text" id="receipt_emails" ref="city"
                                                       v-model="receiptEmailsForm.receipt_emails"
                                                       :placeholder="'Email Addresses'"
                                                       class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"/>
                                            </div>
                                        </div>

                                        <div class="px-6 py-4 mt-5 bg-gray-100 bg-opacity-50 border-t border-gray-100 text-right">
                                            <spark-button @click.native="updateReceiptEmails">
                                                Save
                                            </spark-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Receipts -->
                            <div class="mt-10" v-if="$page.props.receipts.length > 0">
                                <section-heading class="px-4 sm:px-8">
                                    Faktury
                                </section-heading>

                                <receipt-list class="mt-3 sm:px-8" :receipts="$page.props.receipts"/>
                            </div>

                            <div class="text-center mt-10 lg:hidden" id="footerTermsLink" v-if="$page.props.termsUrl">
                                <a :href="$page.props.termsUrl" target="_blank" class="text-gray-600 underline">
                                    Obchodní podmínky
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="overlay" v-if="processing">
                <div class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
    </app-layout>

    <!-- bg-gray-50 bg-gray-100 bg-gray-200 bg-gray-300 bg-gray-400 bg-gray-500 bg-gray-600 bg-gray-700 bg-gray-800 bg-gray-900 -->
    <!-- bg-red-50 bg-red-100 bg-red-200 bg-red-300 bg-red-400 bg-red-500 bg-red-600 bg-red-700 bg-red-800 bg-red-900 -->
    <!-- bg-yellow-50 bg-yellow-100 bg-yellow-200 bg-yellow-300 bg-yellow-400 bg-yellow-500 bg-yellow-600 bg-yellow-700 bg-yellow-800 bg-yellow-900 -->
    <!-- bg-green-50 bg-green-100 bg-green-200 bg-green-300 bg-green-400 bg-green-500 bg-green-600 bg-green-700 bg-green-800 bg-green-900 -->
    <!-- bg-blue-50 bg-blue-100 bg-blue-200 bg-blue-300 bg-blue-400 bg-blue-500 bg-blue-600 bg-blue-700 bg-blue-800 bg-blue-900 -->
    <!-- bg-indigo-50 bg-indigo-100 bg-indigo-200 bg-indigo-300 bg-indigo-400 bg-indigo-500 bg-indigo-600 bg-indigo-700 bg-indigo-800 bg-indigo-900 -->
    <!-- bg-purple-50 bg-purple-100 bg-purple-200 bg-purple-300 bg-purple-400 bg-purple-500 bg-purple-600 bg-purple-700 bg-purple-800 bg-indigo-900 -->
    <!-- bg-pink-50 bg-pink-100 bg-pink-200 bg-pink-300 bg-pink-400 bg-pink-500 bg-pink-600 bg-pink-700 bg-pink-800 bg-indigo-900 -->
</template>

<script>
import ErrorMessages from "../../Components/ErrorMessages";
import InfoMessages from "../../Components/InfoMessages";
import FormatsValues from './../../Mixins/FormatsValues';
import IntervalSelector from './../../Components/IntervalSelector';
import Plan from './../../Components/Plan';
import PlanList from './../../Components/PlanList';
import PlanSectionHeading from './../../Components/PlanSectionHeading';
import ReceiptList from './../../Components/ReceiptList';
import SectionHeading from './../../Components/SectionHeading';
import SparkButton from './../../Components/Button';
import SparkSecondaryButton from './../../Components/SecondaryButton';
import {Inertia} from '@inertiajs/inertia'
import AppLayout from "../../Layouts/AppLayout";
import SettingsTabsNavigation from "./SettingsTabsNavigation";
import Label from "../../Jetstream/Label";

export default {
    mixins: [FormatsValues],

    components: {
        'jet-label': Label,
        SettingsTabsNavigation,
        AppLayout,
        ErrorMessages,
        InfoMessages,
        IntervalSelector,
        Plan,
        PlanList,
        PlanSectionHeading,
        ReceiptList,
        SectionHeading,
        SparkButton,
        SparkSecondaryButton,
    },

    props: [
        'billableId',
        'billableType',
        'enforcesAcceptingTerms',
        'collectsVat',
        'collectsBillingAddress',
        'monthlyPlans',
        'paddleVendorId',
        'paymentMethod',
        'plan',
        'seatName',
        'userName',
        'yearlyPlans',
    ],

    data() {
        return {
            errors: [],
            processing: false,
            stripe: null,

            showingPlansOfInterval: 'monthly',

            subscribing: null,
            subscriptionCardElement: null,
            showingCouponCode: false,
            addingVatNumber: false,
            subscriptionForm: {
                paymentLater: true,
                coupon: null,
                country: '',
                accept: false,
                vat: '',
                id_number: '',
                name: '',
                postal_code: '',
                address: '',
                address2: '',
                city: '',
                state: '',
                extra: ''
            },

            checkoutTax: 0,
            checkoutAmount: 0,
            loadingTaxCalculations: true,

            paymentInformationForm: {
                country: '',
                vat: '',
                postal_code: '',
                address: '',
                address2: '',
                city: '',
                state: '',
                extra: ''
            },

            receiptEmailsForm: {
                receipt_emails: '',
            },

            couponForm: {
                coupon: '',
            },

            selectingNewPlan: false,
            updatingPaymentMethod: false,
            paymentMethodCardElement: null,

            billingInformationForm: {
                country: '',
                vat: '',
                id_number: '',
                name: '',
                postal_code: '',
                address: '',
                address2: '',
                city: '',
                state: '',
                extra: '',
            },

            stripeInputsCompleted: false,
        };
    },

    watch: {
        updatingPaymentMethod(val) {
            if (!val) {
                return;
            }

            this.$nextTick(() => {
                this.paymentMethodCardElement = this.createCardElement('#payment-card-element');

                this.paymentMethodCardElement.on('ready', () => {
                    this.paymentMethodCardElement.focus()
                });

                this.paymentMethodCardElement.on('change', (event) => {
                    if (event.complete) {
                        this.stripeInputsCompleted = true;
                    }
                })
            })
        },

        subscribing(val) {
            if (!val) {
                window.history.pushState({}, document.title, window.location.pathname);
            } else {
                window.history.pushState({}, document.title, window.location.pathname + '?subscribe=' + val.id);

                this.calculatingTax(this.subscribing, (data) => {
                    this.checkoutTax = data.tax;
                    this.checkoutAmount = data.total;
                });
            }

            this.checkoutTax = 0;

            if (!this.$page.props.billable.vat_id) {
                this.addingVatNumber = false;
            }
        },

        'subscriptionForm.country'(val) {
            if (!this.$page.props.billable.vat_id) {
                this.addingVatNumber = false;
            }

            if (this.collectsVat && this.subscribing) {
                this.calculatingTax(this.subscribing, (data) => {
                    this.checkoutTax = data.tax;
                    this.checkoutAmount = data.total;
                });
            }
        },

        'subscriptionForm.vat': _.debounce(function () {
            if (this.collectsVat && this.subscribing) {
                this.calculatingTax(this.subscribing, (data) => {
                    this.checkoutTax = data.tax;
                    this.checkoutAmount = data.total;
                });
            }
        }, 500)
    },

    /**
     * Initialize the component.
     */
    mounted() {
        this.stripe = Stripe(this.$page.props.stripeKey, {
            apiVersion: this.$page.props.stripeVersion
        });

        this.subscriptionForm.extra = this.$page.props.billable.extra_billing_information;
        this.subscriptionForm.address = this.$page.props.billable.billing_address;
        this.subscriptionForm.address2 = this.$page.props.billable.billing_address_line_2;
        this.subscriptionForm.city = this.$page.props.billable.billing_city;
        this.subscriptionForm.state = this.$page.props.billable.billing_state;
        this.subscriptionForm.postal_code = this.$page.props.billable.billing_postal_code;
        this.subscriptionForm.country = this.$page.props.billable.billing_country || '';
        this.subscriptionForm.vat = this.$page.props.billable.vat_id;
        this.subscriptionForm.id_number = this.$page.props.billable.billing_id_number;
        this.subscriptionForm.name = this.$page.props.billable.billing_name;

        this.paymentInformationForm.address = this.$page.props.billable.billing_address;
        this.paymentInformationForm.address2 = this.$page.props.billable.billing_address_line_2;
        this.paymentInformationForm.city = this.$page.props.billable.billing_city;
        this.paymentInformationForm.state = this.$page.props.billable.billing_state;
        this.paymentInformationForm.postal_code = this.$page.props.billable.billing_postal_code;
        this.paymentInformationForm.country = this.$page.props.billable.billing_country || 'CZ';
        this.paymentInformationForm.vat = this.$page.props.billable.vat_id;

        if (this.$page.props.billable.vat_id) {
            this.addingVatNumber = true;
        }

        this.billingInformationForm.address = this.$page.props.billable.billing_address;
        this.billingInformationForm.address2 = this.$page.props.billable.billing_address_line_2;
        this.billingInformationForm.city = this.$page.props.billable.billing_city;
        this.billingInformationForm.state = this.$page.props.billable.billing_state;
        this.billingInformationForm.postal_code = this.$page.props.billable.billing_postal_code;
        this.billingInformationForm.country = this.$page.props.billable.billing_country || 'CZ';
        this.billingInformationForm.vat = this.$page.props.billable.vat_id;
        this.billingInformationForm.name = this.$page.props.billable.billing_name;
        this.billingInformationForm.id_number = this.$page.props.billable.billing_id_number;
        this.billingInformationForm.extra = this.$page.props.billable.extra_billing_information;

        this.receiptEmailsForm.receipt_emails = this.$page.props.billable.receipt_emails.join(',');

        Inertia.on('invalid', (event) => {
            console.log('invalid inertia request', event);
            event.preventDefault();

            if (event.detail.response.request.responseURL) {
                window.location.href = event.detail.response.request.responseURL;
            } else {
                console.error(event);
            }
        });

        if (this.monthlyPlans.length == 0 &&
            this.yearlyPlans.length > 0) {
            this.showingPlansOfInterval = 'yearly';
        } else {
            this.showingPlansOfInterval = this.$page.props.defaultInterval;
        }

        if (this.$page.props.state == 'none' && this.$page.props.subscribingTo) {
            this.startSubscribingToPlan(this.$page.props.subscribingTo);
        }

        if (this.collectsVat && !this.$page.props.billable.billing_country) {
            this.subscriptionForm.country = this.$page.props.homeCountry;
        }
    },

    computed: {
        vatComplicit() {
            return this.collectsVat ? _.includes([
                'BE', 'BG', 'CZ', 'DK', 'DE',
                'EE', 'IE', 'GR', 'ES', 'FR',
                'HR', 'IT', 'CY', 'LV', 'LT',
                'LU', 'HU', 'MT', 'NL', 'AT',
                'PL', 'PT', 'RO', 'SI', 'SK',
                'FI', 'SE', 'GB',
            ], this.subscriptionForm.country) : false;
        }
    },

    methods: {
        redirectToConfirmSubscription(){
            this.processing = true;
            this.errors = [];

            let data = {
                plan: this.subscribing.id,
                paymentLater: this.subscriptionForm.paymentLater,
                coupon: this.subscriptionForm.coupon,
                country: this.subscriptionForm.country,
                accept: this.subscriptionForm.accept,
                vat: this.subscriptionForm.vat,
                id_number: this.subscriptionForm.id_number,
                name: this.subscriptionForm.name,
                postal_code: this.subscriptionForm.postal_code,
                address: this.subscriptionForm.address,
                address2: this.subscriptionForm.address2,
                city: this.subscriptionForm.city,
                state: this.subscriptionForm.state,
                extra: this.subscriptionForm.extra,

                billableType: this.billableType,
                billableId: this.billableId,
            };
            axios.post(route('spark.external.stripe'), data)
                .then(response => {
                    window.location = response.data.checkout_url;
                })
                .catch( error => {
                    this.errors = [error.response.data.message];
                    this.reloadData();
                });
        },

        /**
         * Sync information in different arrays with user information
         */
        syncForms(source){
            console.log(source.name);
            this.billingInformationForm.address = source.address;
            this.billingInformationForm.address2 = source.address2;
            this.billingInformationForm.city = source.city;
            this.billingInformationForm.state = source.state;
            this.billingInformationForm.postal_code = source.postal_code;
            this.billingInformationForm.country = source.country;
            this.billingInformationForm.vat = source.vat;
            this.billingInformationForm.name = source.name;
            this.billingInformationForm.id_number = source.id_number;
            this.billingInformationForm.extra = source.extra;

            this.subscriptionForm.address = source.address;
            this.subscriptionForm.address2 = source.address2;
            this.subscriptionForm.city = source.city;
            this.subscriptionForm.state = source.state;
            this.subscriptionForm.postal_code = source.postal_code;
            this.subscriptionForm.country = source.country;
            this.subscriptionForm.vat = source.vat;
            this.subscriptionForm.name = source.name;
            this.subscriptionForm.id_number = source.id_number;
            this.subscriptionForm.extra = source.extra;

            /*
            this.paymentInformationForm.address = source.billing_address;
            this.paymentInformationForm.address2 = source.billing_address_line_2;
            this.paymentInformationForm.city = source.billing_city;
            this.paymentInformationForm.state = source.billing_state;
            this.paymentInformationForm.postal_code = source.billing_postal_code;
            this.paymentInformationForm.country = source.billing_country;
            this.paymentInformationForm.vat = source.vat_id;
            */
        },

        /**
         * Initialize the Stripe Elements for the page.
         */
        createCardElement(container) {
            var card = this.stripe.elements({
                fonts: [{
                    cssSrc: 'https://fonts.googleapis.com/css?family=Nunito:400,600,700'
                }],
            }).create('card', {
                hideIcon: false,
                hidePostalCode: true,
                style: {
                    base: {
                        '::placeholder': {
                            color: '#aab7c4'
                        },
                        fontFamily: 'Nunito, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                        color: '#000000',
                        fontSize: '16px',
                        fontWeight: '400',
                        fontSmoothing: 'antialiased'
                    }
                }
            });

            card.mount(container);

            return card;
        },


        /**
         * Begin the process of subscription to a plan.
         */
        startSubscribingToPlan(plan) {
            this.subscribing = plan;

            this.subscriptionCardElement = this.createCardElement('#card-element');

            this.subscriptionCardElement.on('ready', () => {
                this.subscriptionCardElement.focus()
            });

            this.subscriptionCardElement.on('change', (event) => {
                if (event.complete) {
                    this.stripeInputsCompleted = true;
                }
            })
        },

        /**
         * Actually create a new subscription for the billable.
         */
        confirmSubscription() {
            if (this.enforcesAcceptingTerms && !this.subscriptionForm.accept) {
                this.errors = ['Please accept the terms of service.'];

                return;
            }

            this.processing = true;

            this.generateSetupIntentToken(secret => {
                let payload = {
                    name: this.$page.props.userName
                };

                if (this.subscriptionForm.country) {
                    payload.address = {
                        line1: this.subscriptionForm.address || '',
                        line2: this.subscriptionForm.address2 || '',
                        city: this.subscriptionForm.city || '',
                        state: this.subscriptionForm.state || '',
                        postal_code: this.subscriptionForm.postal_code || '',
                        country: this.subscriptionForm.country || '',
                    }
                }

                this.stripe.handleCardSetup(secret, this.subscriptionCardElement, {
                    payment_method_data: {
                        billing_details: payload
                    }
                }).then(response => {
                    if (response.error) {
                        this.errors = [response.error.message];

                        this.processing = false;
                    } else {
                        this.request('POST', '/spark/subscription', {
                            plan: this.subscribing.id,
                            payment_method: response.setupIntent.payment_method,
                            coupon: this.subscriptionForm.coupon,
                            extra_billing_information: this.subscriptionForm.extra,
                            billing_address: this.subscriptionForm.address,
                            billing_address_line_2: this.subscriptionForm.address2,
                            billing_city: this.subscriptionForm.city,
                            billing_state: this.subscriptionForm.state,
                            billing_postal_code: this.subscriptionForm.postal_code,
                            billing_country: this.subscriptionForm.country,
                            vat_id: this.subscriptionForm.vat,
                            id_number: this.subscriptionForm.id_number,
                            name: this.subscriptionForm.name,
                        }).then(response => {
                            this.syncForms(this.subscriptionForm);

                            this.billingInformationForm.coupon = this.subscriptionForm.coupon;

                            if (response && response.data.paymentId) {
                                window.location = '/' + this.$page.props.cashierPath + '/payment/' + response.data.paymentId + '?redirect=' + window.location.origin + '/' + this.$page.props.sparkPath;
                            } else if (response) {
                                this.reloadData();
                            } else {
                                this.processing = false;
                            }
                        });
                    }
                });
            });
        },

        /**
         * Switch to the given plan.
         */
        switchToPlan(plan) {
            this.processing = true;

            this.request('PUT', '/spark/subscription', {
                plan: plan.id,
            }).then(response => {
                this.reloadData();
            });
        },

        /**
         * Toggle the plan intervals that are being displayed.
         */
        toggleDisplayedPlanIntervals() {
            if (this.showingPlansOfInterval == 'monthly') {
                this.showingPlansOfInterval = 'yearly';
            } else {
                this.showingPlansOfInterval = 'monthly';
            }
        },

        /**
         * Show the coupon code entry field.
         */
        showCouponCode() {
            this.showingCouponCode = true;

            this.$nextTick(() => this.$refs.coupon.focus());
        },

        /**
         * Show the VAT number entry field.
         */
        showVatNumber() {
            this.addingVatNumber = true;

            this.$nextTick(() => this.$refs.vat.focus());
        },

        /**
         * Update the customer's payment method.
         */
        updatePaymentMethod() {
            this.processing = true;

            this.generateSetupIntentToken(secret => {
                let payload = {
                    name: this.$page.props.userName
                };

                if (this.subscriptionForm.country) {
                    payload.address = {
                        line1: this.paymentInformationForm.address || '',
                        line2: this.paymentInformationForm.address2 || '',
                        city: this.paymentInformationForm.city || '',
                        state: this.paymentInformationForm.state || '',
                        postal_code: this.paymentInformationForm.postal_code || '',
                        country: this.paymentInformationForm.country || '',
                    }
                }

                this.stripe.handleCardSetup(secret, this.paymentMethodCardElement, {
                    payment_method_data: {
                        billing_details: payload
                    }
                }).then(response => {
                    if (response.error) {
                        this.errors = [response.error.message];

                        this.processing = false;
                    } else {
                        this.request('PUT', '/spark/subscription/payment-method', {
                            payment_method: response.setupIntent.payment_method,
                            billing_address: this.paymentInformationForm.address,
                            billing_address_line_2: this.paymentInformationForm.address2,
                            billing_city: this.paymentInformationForm.city,
                            billing_state: this.paymentInformationForm.state,
                            billing_postal_code: this.paymentInformationForm.postal_code,
                            billing_country: this.paymentInformationForm.country,
                            vat_id: this.paymentInformationForm.vat,
                        }).then(response => {
                            if (response) {
                                this.reloadData();

                                this.paymentMethodCardElement.clear();

                                this.stripeInputsCompleted = false;
                            } else {
                                this.processing = false;
                            }
                        });
                    }
                });
            });
        },

        /**
         * Generate a Stripe Setup Intent token.
         */
        generateSetupIntentToken(callback) {
            return this.request('GET', '/spark/token').then(
                response => callback(response.data.clientSecret)
            );
        },

        /**
         * Update the extra billing information for the customer.
         */
        updateBillingInformation() {
            this.processing = true;

            this.request('PUT', '/spark/billing-information', {
                address: this.billingInformationForm.address,
                address2: this.billingInformationForm.address2,
                city: this.billingInformationForm.city,
                state: this.billingInformationForm.state,
                postal_code: this.billingInformationForm.postal_code,
                country: this.billingInformationForm.country,
                vat: this.billingInformationForm.vat,
                name: this.billingInformationForm.name,
                id_number: this.billingInformationForm.id_number,
                extra_billing_information: this.billingInformationForm.extra,
            }).then(response => {
                this.syncForms(this.billingInformationForm);

                this.reloadData();
            });
        },

        /**
         * Update the email addresses we send receipts to.
         */
        updateReceiptEmails() {
            this.processing = true;

            this.request('PUT', '/spark/receipt-emails', {
                receipt_emails: this.receiptEmailsForm.receipt_emails,
            }).then(response => {
                this.reloadData();
            });
        },

        /**
         * Apply a coupon to the existing subscription.
         */
        applyCoupon() {
            this.processing = true;

            this.request('PUT', '/spark/coupon', {
                coupon: this.couponForm.coupon,
            }).then(response => {
                this.reloadData();
            });
        },

        /**
         * Cancel the customer's subscription.
         */
        cancelSubscription() {
            this.processing = true;

            this.request('PUT', '/spark/subscription/cancel').then(response => {
                this.reloadData();
            });
        },

        /**
         * Resume a cancelled subscription.
         */
        resumeSubscription() {
            this.processing = true;

            this.request('PUT', '/spark/subscription/resume', {}).then(response => {
                this.reloadData();
            });
        },

        /**
         * Calculate the appropriate TAX for the given total.
         */
        calculatingTax(plan, callback) {
            this.loadingTaxCalculations = true;

            return this.request('POST', '/spark/tax-rate', {
                total: plan.raw_price,
                currency: plan.currency,
                vat_number: this.subscriptionForm.vat,
                country: this.subscriptionForm.country,
                postal_code: this.subscriptionForm.postal_code,
            }).then(response => {
                this.loadingTaxCalculations = false;

                callback(response.data)
            });
        },

        /**
         * Start periodically reloading the page's data.
         */
        startReloadingData() {
            setTimeout(() => {
                this.reloadData();
            }, 1000)
        },

        /**
         * Reload the page's data, while maintaining any current state.
         */
        reloadData() {
            return this.$inertia.reload({
                onSuccess: () => {
                    this.selectingNewPlan = false;
                    this.processing = false;
                    this.subscribing = null;
                    this.updatingPaymentMethod = false;
                }
            });
        },

        /**
         * Make an outgoing request to the Laravel application.
         */
        request(method, url, data = {}) {
            this.errors = [];

            data.billableType = this.billableType;
            data.billableId = this.billableId;

            return axios.request({
                url: url,
                method: method,
                data: data,
            }).then(response => {
                return response;
            }).catch(error => {
                if (error.response.status == 422) {
                    this.errors = _.flatMap(error.response.data.errors)
                } else {
                    this.errors = ['Nastala neočekávaná chyba! Náš tým na ni byl upozorněn. Zkuste to prosím později.']
                }

                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            });
        },
    },
}
</script>

<style scoped>

.form-select {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%2364748B' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3E%3C/svg%3E");
    background-position: right 16px center;
    background-repeat: no-repeat;
    background-size: 1.5em 1.5em;
    padding-right: 16px;
    color-adjust: exact;
}

.component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .2s ease;
}

.component-fade-enter, .component-fade-leave-to {
    opacity: 0;
}

div#overlay{
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(16, 16, 16, 0.5);
}

.lds-ring {
    display: inline-block;
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 80px;
    height: 80px;
}

.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fff transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}

@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

button[disabled]{
    opacity: .25;
    cursor: not-allowed;
}

</style>
